export enum SearchStatus {
  READY,
  PRE_ANALYSIS,
  SEARCHING,
  FINALIZING,
  ABORTING,
}
